import { inputDescLimit, inputTextLimit } from '../../../helpers/fieldRestriction';
import messages from '../../../locale/jsonMessages';

const validate = values => {
  const errors = {};

  if (!values.pageUrl) {
    errors.pageUrl = messages.required;
  } else {
    const slashCount = (values.pageUrl.match(/\//g) || []).length;
    const questionCount = (values.pageUrl.match(/\?/g) || []).length;
    const andCount = (values.pageUrl.match(/\&/g) || []).length;
    if (slashCount >= 1 || questionCount >= 1 || andCount >= 1) {
      errors.pageUrl = messages.invalidPageUrl;
    }
  }

  if (!values.footerCategory || values.footerCategory === '') {
    errors.footerCategory = messages.required;
  }

  if (values?.dynamicBlogDetails && values.dynamicBlogDetails.length > 0) {
    const dynamicErrors = values.dynamicBlogDetails.map(item => {
      const itemErrors = {};

      if (!item?.language) {
        itemErrors.language = messages.required;
      }

      if (!item?.metaTitle) {
        itemErrors.metaTitle = messages.required;
      } else if (item.metaTitle.trim() === '') {
        itemErrors.metaTitle = messages.required;
      } else if (item.metaTitle.length > inputTextLimit) {
        itemErrors.metaTitle = messages.inputTextLimitError;
      }

      if (!item?.metaDescription) {
        itemErrors.metaDescription = messages.required;
      } else if (item.metaDescription.trim() === '') {
        itemErrors.metaDescription = messages.required;
      } else if (item.metaDescription.length > inputDescLimit) {
        itemErrors.metaDescription = messages.inputDescLimitError;
      }

      if (!item?.pageTitle) {
        itemErrors.pageTitle = messages.required;
      } else if (item.pageTitle.trim() === '') {
        itemErrors.pageTitle = messages.required;
      } else if (item.pageTitle.length > inputTextLimit) {
        itemErrors.pageTitle = messages.inputTextLimitError;
      }

      const stripped = item?.content
        ?.replace(/<[^>]+>/g, '')
        ?.replace(/&nbsp;/gi, '')
        ?.replace(/\s+/g, '')
        ?.trim();

      if (!item?.content || item.content === '<p><br></p>' || item.content === '<p> </p>' || !stripped) {
        itemErrors.content = messages.required;
      }

      return itemErrors;
    });

    if (dynamicErrors.some(e => Object.keys(e).length > 0)) {
      errors.dynamicBlogDetails = dynamicErrors;
    }
  }

  return errors;
};

export default validate;